import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, of } from 'rxjs';
import { environment } from 'src/environments/environment';

interface ResRole {
  message: string;
  result: {
    ROLE: string;
    IS_TA: boolean;
  }
  success: true
}

interface resProfile {
  message: string;
  success: boolean;
  result: {
    ROLE: string;
    IS_PREMIUM: boolean;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _token = new BehaviorSubject<string>(null);

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  get token() {
    return this._token.asObservable();
  }

  getRole() {
    let token;
    this.token.subscribe(res => token = res);
    const headers = new HttpHeaders({ Authorization: token });

    return this.http.get<ResRole>(environment.URL + '/authen/CheckRole', { headers: headers });
  }

  getToken() {
    this._token.next(this.cookieService.get('token'));

    return this.cookieService.get('token');
  }

  deleteTokenLogout() {
    this.cookieService.delete('token');
    this.cookieService.deleteAll();
    this._token.next(null);
    return of(true);
  }

  getProfile() {
    const headers = new HttpHeaders({ Authorization: this.cookieService.get('token') });

    return this.http.get<resProfile>(environment.URL + '/authen/GetProfile', { headers: headers });
  }
}
